var _path, _path2, _path3, _path4, _path5;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgQrScan = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20 3c0-1.654-1.346-3-3-3h-10c-1.654 0-3 1.346-3 3v18c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3zm-2 18c0 .552-.448 1-1 1h-10c-.552 0-1-.448-1-1v-18c0-.552.448-1 1-1h.5c.552 0 1 .448 1 1 0 .552.448 1 1 1h5c.552 0 1-.448 1-1 0-.552.448-1 1-1h.5c.552 0 1 .448 1 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.75 12c-.414 0-.75-.336-.75-.75v-1.5c0-.965.785-1.75 1.75-1.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75h-1.5c-.138 0-.25.112-.25.25v1.5c0 .414-.336.75-.75.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.25 12c-.414 0-.75-.336-.75-.75v-1.5c0-.138-.112-.25-.25-.25h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.965 0 1.75.785 1.75 1.75v1.5c0 .414-.336.75-.75.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m10.25 18h-1.5c-.965 0-1.75-.785-1.75-1.75v-1.5c0-.414.336-.75.75-.75s.75.336.75.75v1.5c0 .138.112.25.25.25h1.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m15.25 18h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.138 0 .25-.112.25-.25v-1.5c0-.414.336-.75.75-.75s.75.336.75.75v1.5c0 .965-.785 1.75-1.75 1.75z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQrScan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/qr_scan.05065d41.svg";
export { ForwardRef as ReactComponent };